module.exports = __webpack_public_path__ + "static/media/020.40cc171c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/020.jpg
// module id = 367
// module chunks = 0